import React from "react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="content-footer footer bg-footer-theme" style={{ backgroundColor: '#fff', }}>
            <div className="container-xxl">
                <div style={{fontSize:"13px"}} className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
                    
                    {/* Left Side Content */}
                    <div className="mb-2 mb-md-0" >Copyright
                        © {currentYear} {" "}

                       Vitaura Life Sciences Pvt Ltd.
                       
                    </div>

                    {/* Right Side Content */}
                    <div className="footer-links d-flex align-items-center gap-1">
                     Developed by 
                      <a href="https://gdrbtechnologies.com/" target="_blank" rel="noopener noreferrer" className="footer-link">
                       GDRB Technologies Pvt Ltd.
                        </a>
                    
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
